// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"5230483d","387":"16ebc8ce","417":"42d82a54","930":"906f8a99"}[chunkId] + ".chunk.css";
};